export const getGlobalPermissions = (permissions) => {
    return permissions.filter(permission => permission.isGlobal);
};
export const getUnitAccessPermissions = (permissions, unitId) => {
    return permissions.filter(permission => permission.unit?.id === unitId);
};

export const checkPermission = (permissions, permission, unitId, entityType = null, entityId = null, entityName = null) => {
    const permissionFromUser = [...getUnitAccessPermissions(permissions, unitId),...getGlobalPermissions(permissions)];
    if ((entityId || entityName) && entityType) {
        return permissionFromUser.some(item => {
                return item.type === permission &&
                    item.context && item.context.entity_type === entityType &&
                    (item.context.entity_id === entityId || item.context.entity_name === entityName);
            }
        );
    } else {
        return permissionFromUser.some(item => item.type === permission);
    }
};

export const checkPermissionsFromUser = (permissions, permissionsFromUser, unitId, entityType = null, entityId = null, entityName = null) => {
    return permissionsFromUser.some(permission =>
        checkPermission(permissions, permission, unitId, entityType, entityId, entityName)
    );
};

export const hasAnyPermission = (permissions, permissionsToCheck, unitId) => {
    const permissionFromUser = [
        ...getUnitAccessPermissions(permissions, unitId),
        ...getGlobalPermissions(permissions)
    ];

    return permissionsToCheck.some(permissionToCheck =>
        permissionFromUser.some(item => item.type === permissionToCheck)
    );
};

export const checkPermissions = (permissionsFromUser, company, permissions, children) => {
    if (!permissionsFromUser || !permissions || !company?.unitId) {
        return null;
    }

    return hasAnyPermission(permissionsFromUser, permissions, company.unitId) ? children : null;
};

// Ordem de preferência para onde mandar o usuário quando a rota atual não é
// permitida (ou logo após o login). Espelha a ordem do menu lateral
// (DrawerSider) e as permissões de src/routes.js — manter em sincronia.
const FALLBACK_ROUTES = [
    { path: "/dashboard/resumo", permissions: ["VIEW_MAIN_DASHBOARD"] },
    {
        path: "/usuarios-e-permissoes",
        permissions: [
            "CREATE_USER",
            "MANAGE_ROLES",
            "DELETE_USER",
            "UPDATE_USER",
            "RESET_PASSWORD",
            "REQUEST_PASSWORD_CHANGE"
        ]
    },
    {
        path: "/formularios/categoria/todas",
        permissions: ["CREATE_CATEGORY", "UPDATE_CATEGORY", "DELETE_CATEGORY"]
    },
    {
        path: "/formularios/todos",
        permissions: [
            "CREATE_FORM",
            "EDIT_FORM",
            "DELETE_FORM",
            "CREATE_FIELD_IN_FORM",
            "EDIT_FIELD_IN_FORM",
            "DELETE_FIELD_IN_FORM",
            "ORDER_FIELDS_IN_FORM",
            "INSERT_DATA_IN_FORM",
            "EDIT_DATA_IN_FORM",
            "DELETE_DATA_IN_FORM",
            "VIEW_DATA_FROM_FORM",
            "IMPORT_DATA_IN_FORM",
            "VIEW_DATA_ARCHIVED_FROM_FORM"
        ]
    },
    { path: "/relatorios", permissions: ["VIEW_REPORT_EMBED"] },
    { path: "/atividades/todas", permissions: ["VIEW_ACTIVITY_LOG"] },
    {
        path: "/automacoes",
        permissions: [
            "CREATE_AUTOMATION",
            "EDIT_AUTOMATION",
            "DELETE_AUTOMATION",
            "VIEW_LOG_AUTOMATION"
        ]
    }
];

/**
 * Retorna a primeira rota que o usuário tem permissão de acessar, na ordem do
 * menu. Quem não tem nenhuma permissão de menu cai em /perfil (só exige
 * autenticação); /403 fica apenas para o caso de dados ainda não carregados.
 */
export const getFirstAllowedRoute = (permissions, unitId) => {
    if (!permissions || !unitId) {
        return "/403";
    }
    const route = FALLBACK_ROUTES.find(({ permissions: required }) =>
        hasAnyPermission(permissions, required, unitId)
    );
    return route ? route.path : "/perfil";
};

export const getAllPermissionsByUnit = (permissions, unitId, permissionsToFilter  = []) =>{
    const unitPermissions = getUnitAccessPermissions(permissions, unitId);
    const globalPermissions = getGlobalPermissions(permissions);
    return [
        ...unitPermissions,
        ...globalPermissions
    ].filter(item => {
        if(permissionsToFilter.length === 0){
            return true;
        }else{
            return permissionsToFilter.includes(item.type)
        }
    });
}
